module.exports = __webpack_public_path__ + "img/subheader01_mid.25c5b19b.jpg";